import http from '../utils/http';
export default{
    GetRoleList(RoleItemStr=''){
        let postData = { apiID: '14F081CE-567B-4912-9063-39097BF5BD64'//AddRoleSet
            , data: {  RoleItemStr : RoleItemStr } };
        return http.post(sys.apiUrl, postData)
    },
}


// WEBPACK FOOTER //
// ./src/api/sys.api.js